module.exports = "/build/images/garbageIcon-white.svg?71addb4bf1f20a2e1126179ade00c3c8";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/garbageIcon-white.svg
// module id = 1014
// module chunks = 0